export default __webpack_public_path__ + "static/media/DFDK_Wortmarke_CMYK_anthrazit.53273dce.png";